<div class="mt-3 border border-slate-200 rounded-xl overflow-hidden">
  <button type="button" (click)="toggle()"
    class="w-full flex items-center justify-between gap-2 px-3 py-2.5 bg-slate-50 text-left hover:bg-slate-100">
    <span class="flex items-center gap-2 text-sm font-semibold text-slate-700">
      <mat-icon class="text-base">toll</mat-icon>
      Coin acceptor
      @if (coinAcceptor(); as coins) {
      <span class="px-2 py-0.5 rounded-full border text-[11px] font-semibold" [ngClass]="statusClass()">
        {{ coins.isEnabled ? coins.status : 'Disabled' }}
      </span>
      }
    </span>
    <mat-icon class="text-base text-slate-500">{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>

  @if (expanded()) {
  <div class="p-3 space-y-3 bg-white">
    @if (loading()) {
    <div class="flex justify-center py-4"><mat-spinner diameter="24"></mat-spinner></div>
    } @else if (loaded()) {

    @if (coinAcceptor(); as coins) {
    <dl class="grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
      <dt class="text-slate-500">Status</dt>
      <dd class="font-semibold text-slate-800">{{ coins.status }}{{ coins.isOnline ? ' · online' : '' }}</dd>
      @if (coins.statusDetail) {
      <dt class="text-slate-500">Detail</dt>
      <dd class="text-slate-700 break-words">{{ coins.statusDetail }}</dd>
      }
      <dt class="text-slate-500">Last report</dt>
      <dd class="text-slate-700">{{ coins.lastStatusAt ? (coins.lastStatusAt | date:'dd.MM.yyyy HH:mm:ss') : '—' }}</dd>
    </dl>
    }

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-3">
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [ngModel]="deviceName()" (ngModelChange)="deviceName.set($event)" [disabled]="saving() || disabled()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Serial number</mat-label>
        <input matInput [ngModel]="serialNumber()" (ngModelChange)="serialNumber.set($event)" [disabled]="saving() || disabled()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Inactivity timeout (s)</mat-label>
        <input matInput type="number" min="30" max="900" [ngModel]="timeoutSeconds()"
          (ngModelChange)="timeoutSeconds.set(+$event)" [disabled]="saving() || disabled()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Cash box capacity (€)</mat-label>
        <input matInput type="number" min="1" max="10000" step="1" [ngModel]="capacityEuros()"
          (ngModelChange)="capacityEuros.set(+$event)" [disabled]="saving() || disabled()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Alert at (% full)</mat-label>
        <input matInput type="number" min="1" max="100" [ngModel]="alertPercent()"
          (ngModelChange)="alertPercent.set(+$event)" [disabled]="saving() || disabled()">
      </mat-form-field>
      <div class="flex items-center justify-between px-1 pb-4">
        <span class="text-sm font-semibold text-slate-700">Enabled</span>
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" [checked]="isEnabled()" (change)="isEnabled.set(!isEnabled())" class="sr-only peer"
            [disabled]="saving() || disabled()">
          <div class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
        </label>
      </div>
    </div>

    <div>
      <div class="text-xs font-semibold text-slate-600 mb-1.5">Accepted coins</div>
      <div class="flex flex-wrap gap-2">
        @for (cents of euroCoins; track cents) {
        <button type="button" (click)="toggleCoin(cents)" [disabled]="saving() || disabled()"
          class="px-3 py-1 rounded-full border text-xs font-semibold transition-colors"
          [class.bg-blue-50]="coinValues().has(cents)" [class.border-blue-300]="coinValues().has(cents)"
          [class.text-blue-700]="coinValues().has(cents)"
          [class.bg-white]="!coinValues().has(cents)" [class.border-slate-200]="!coinValues().has(cents)"
          [class.text-slate-500]="!coinValues().has(cents)">
          {{ coinLabel(cents) }}
        </button>
        }
      </div>
    </div>

    <div class="flex justify-end gap-2">
      @if (coinAcceptor()) {
      <button mat-stroked-button color="warn" (click)="remove()" [disabled]="saving() || disabled()">
        <mat-icon>delete</mat-icon> Remove
      </button>
      }
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!canSave() || saving() || disabled()">
        @if (saving()) { <mat-spinner diameter="18"></mat-spinner> } @else { <mat-icon>save</mat-icon> }
        {{ coinAcceptor() ? 'Save' : 'Register' }}
      </button>
    </div>
    }
  </div>
  }
</div>
